import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import type { ButtonProps } from "@ui/components/forms/button/Button";
import { IconButton } from "@ui/components/forms/icon-button/IconButton";
import { ECCOIcon } from "@ui/components/media-and-icons/ecco-icon/ECCOIcon";
import { Flex } from "@ui/components/layout/flex/Flex";
import { sizes } from "@ui/design-tokens";
import React from "react";
import { useSwiper } from "swiper/react";

const videoControlStyles: ButtonProps["sx"] = {
    backgroundColor: "transparent",
    color: "white",
    backdropFilter: "blur(50px)",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.10)",
    aspectRatio: 1,
};

interface videoControlProps {
    isVideoPlaying: boolean;
    setIsVideoPlaying: (isPlaying: boolean) => void;
    isVideoMuted: boolean;
    setIsVideoMuted: (isMuted: boolean) => void;
    isCarousel: boolean;
}

export const HeroVideoControls = ({
    isVideoMuted,
    setIsVideoMuted,
    isCarousel,
}: videoControlProps) => {
    const { getMultiple } = useMicrocopy();

    const swiper = useSwiper();

    const microcopies = (() => {
        return getMultiple(CommonCMS.shared, [
            CommonCMS.video.ariaPlay,
            CommonCMS.video.ariaPause,
            CommonCMS.video.ariaMute,
            CommonCMS.video.ariaUnmute,
        ]);
    })();

    return (
        <Flex
            gap={"0.2"}
            // Video controls belongs to the slide, so we will arrange them based on the Carousel navigation placement.
            // Button width (52px * 2) + gap (1px) + padding (desktop: 30px, mobile: 15px)
            right={[undefined, isCarousel ? "189px" : 6]}
            left={[isCarousel ? "173px" : 3, "inherit"]}
            zIndex={4}
            position={"absolute"}
            bottom={[3, 6]}
        >
            <IconButton
                variant={"transparent"}
                sx={videoControlStyles}
                height={[
                    sizes.navBarCollapsedHeight,
                    sizes.navBarCollapsedHeight,
                    sizes.navBarCollapsedHeight,
                ]}
                aria-pressed={isVideoMuted}
                aria-label={
                    isVideoMuted
                        ? microcopies[CommonCMS.video.ariaUnmute]
                        : microcopies[CommonCMS.video.ariaMute]
                }
                onClick={() => {
                    swiper && swiper.autoplay.stop();
                    setIsVideoMuted(!isVideoMuted);
                }}
                icon={<ECCOIcon size="3xs" name={isVideoMuted ? "mute" : "volume"} />}
            />
        </Flex>
    );
};

export default HeroVideoControls;
